module.exports = __webpack_public_path__ + "static/media/xray-training-lateral-nonflex4.a1dc38db.png";